import { render, staticRenderFns } from "./PruningReasonRejections.vue?vue&type=template&id=23d735fc"
import script from "./PruningReasonRejections.vue?vue&type=script&lang=js"
export * from "./PruningReasonRejections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports